import request from '@utils/request'
import { ReturnType } from './types'

const allNotification = async (actions: any, params: any) => {
  try {
    const config: ReturnType = {
      url: `users/notifications`,
      method: 'get',
      params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: actions,
          key: 'notifications',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const allAdminsNotification = async (actions: any, params: any) => {
  try {
    const config: ReturnType = {
      url: `admins/notifications`,
      method: 'get',
      params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: actions,
          key: 'notifications',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const userMarkAsReadAll = async () => {
  try {
    const config: ReturnType = {
      url: 'users/notifications/mark-all-read',
      method: 'patch',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const adminMarkAsReadAll = async () => {
  try {
    const config: ReturnType = {
      url: 'admins/notifications/mark-all-read',
      method: 'patch',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const userNotificationCount = async () => {
  try {
    const config: ReturnType = {
      url: 'users/notifications/count-unread',
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const adminNotificationCount = async () => {
  try {
    const config: ReturnType = {
      url: 'admin/notifications/count-unread',
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

export default {
  allNotification,
  allAdminsNotification,
  userMarkAsReadAll,
  userNotificationCount,
  adminMarkAsReadAll,
  adminNotificationCount,
}
